module.exports = "/packs/images/homepage/activity/performing_arts_retina~2773d5ba6615c5615ee96abcae482753.jpg";